/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type useS3UploadMutationVariables = {
    contentType: string;
    fileExtension: string;
};
export type useS3UploadMutationResponse = {
    readonly generateUploadUrl: {
        readonly formData: ReadonlyArray<{
            readonly key: string;
            readonly value: string;
        }>;
        readonly url: string;
        readonly objectKey: string;
    } | null;
};
export type useS3UploadMutation = {
    readonly response: useS3UploadMutationResponse;
    readonly variables: useS3UploadMutationVariables;
};



/*
mutation useS3UploadMutation(
  $contentType: String!
  $fileExtension: String!
) {
  generateUploadUrl(contentType: $contentType, fileExtension: $fileExtension) {
    formData {
      key
      value
    }
    url
    objectKey
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fileExtension"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                },
                {
                    "kind": "Variable",
                    "name": "fileExtension",
                    "variableName": "fileExtension"
                }
            ],
            "concreteType": "GenerateUploadUrlResponse",
            "kind": "LinkedField",
            "name": "generateUploadUrl",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "GenerateUploadUrlResponseFormDataField",
                    "kind": "LinkedField",
                    "name": "formData",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "key",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "objectKey",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "useS3UploadMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "useS3UploadMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "1dc4aa4997efa41b574a678e60022672",
            "id": null,
            "metadata": {},
            "name": "useS3UploadMutation",
            "operationKind": "mutation",
            "text": "mutation useS3UploadMutation(\n  $contentType: String!\n  $fileExtension: String!\n) {\n  generateUploadUrl(contentType: $contentType, fileExtension: $fileExtension) {\n    formData {\n      key\n      value\n    }\n    url\n    objectKey\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '306660b08eaaba02e08f3f17e80c3e19';
export default node;
